<div class="content">
    <div class="selectors">
        <igx-date-picker type="border" [(ngModel)]="date" (valueChange)="dateChange($event)"
            [disabled]="!kids || kids.length == 0" [disabled]="true">
            <label igxLabel>Избери дата</label>
        </igx-date-picker>
        <igx-combo #teachersCombo type="border" [data]="teachers | sorting" [disabled]="!date"
            (selectionChanging)="teachersChange($event)" valueKey="id" displayKey="firstName">
            <label igxLabel>Избери отговорници</label>
            <ng-template igxComboItem let-teacher>
                {{ teacher.firstName }} {{teacher.lastName}}
            </ng-template>
        </igx-combo>
        <button [disabled]="participants.length || date === undefined" igxButton="contained"
            (click)="save()">Запази</button>
    </div>
    <div *ngIf="date" class="selectors">
        <div style="width: 50%;">
            <h5 class="header">{{participants.length}} деца</h5>
            <div class="cards">
                <igx-card class="card" elevated>
                    <igx-card-header>
                        <h5 igxCardHeaderSubtitle>Участници</h5>
                    </igx-card-header>
                    <igx-card-content>
                        <igx-chips-area>
                            <igx-chip *ngFor="let participant of participants" [id]="participant.id!"
                                [draggable]="true">{{participant.name}}
                            </igx-chip>
                        </igx-chips-area>
                    </igx-card-content>
                    <igx-card-actions>
                        <igx-select #select type="border" (selectionChanging)="moveAllKidsToTeacher($event, select)">
                            <label igxLabel>Избери ръководител</label>
                            <igx-select-item *ngFor="let teacher of selectedTeachers" [value]="teacher">
                                {{teacher.firstName}} {{teacher.lastName}}
                            </igx-select-item>
                        </igx-select>
                    </igx-card-actions>
                </igx-card>
            </div>
        </div>
        <div style="width: 50%;">
            <h5 class="header">Разпределение по групи</h5>
            <div class="cards">
                <igx-card class="card" *ngFor="let group of groups" elevated>
                    <igx-card-header>
                        <h3 igxCardHeaderTitle>{{ teacherName(group.teacher.id) }}</h3>
                        <h5 igxCardHeaderSubtitle>Общо {{ group.participants.length }} деца</h5>
                    </igx-card-header>
                    <igx-chips-area igxDrop (dropped)="addToGroup($event, group)">
                        <igx-card-content [style.background]="'hsla(var(--igx-grays-200))'">
                            <igx-chip *ngFor="let kid of kidOnGroup(group)" [id]="kid.id!" [removable]="true"
                                [draggable]="true" (remove)="removeKidFromGroup(kid, group)">{{ kid.name }}</igx-chip>
                        </igx-card-content>
                    </igx-chips-area>
                </igx-card>
            </div>
        </div>
    </div>
</div>